import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "input-box d-md-flex" }
const _hoisted_2 = {
  key: 0,
  class: "list-group position-absolute"
}
const _hoisted_3 = {
  key: 0,
  class: "search-type"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Руководитель:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Адрес:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "ИНН:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "ОГРН:", -1)
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Руководитель:", -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Адрес:", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "ИНН:", -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 3,
  class: "list-group-item"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BuyASubscriptionWarningModal = _resolveComponent("BuyASubscriptionWarningModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control",
        placeholder: "Поиск компании ИНН или Названию",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args)))
      }, null, 544), [
        [_vModelText, _ctx.searchQuery]
      ]),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args)))
      }, "Поиск"),
      (_ctx.searchQuery && _ctx.isFocused)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
            (_ctx.searchResultsIP.length && _ctx.searchResultsINN?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createTextVNode(" Искать по: "),
                  (_ctx.searchResultsINN.length)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: _normalizeClass([{ select: _ctx.selectMode === 'inn' || _ctx.selectMode === 'start' }, "ms-2 btn-small"]),
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectMode = 'inn'))
                      }, " Компаниям ", 2))
                    : _createCommentVNode("", true),
                  (_ctx.searchResultsIP.length)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: _normalizeClass([{ select: _ctx.selectMode === 'ip' }, "ms-4 btn-small"]),
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectMode = 'ip'))
                      }, " ИП ", 2))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (
          (_ctx.selectMode === 'inn' || _ctx.selectMode === 'start') &&
          _ctx.searchResultsINN.length &&
          !_ctx.isLoading
        )
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.searchResultsINN, (company) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: company['ИНН'],
                    class: "list-group-item",
                    onClick: ($event: any) => (_ctx.goToCompany(company['ИНН'] || company['ОГРН']))
                  }, [
                    _createElementVNode("h5", null, _toDisplayString(company["НаимСокр"] || company["ФИО"]), 1),
                    (company['Руковод'] && company['Руковод'][0])
                      ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                          _hoisted_6,
                          _createTextVNode(" " + _toDisplayString(company["Руковод"][0]["ФИО"]), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", null, [
                      _hoisted_7,
                      _createTextVNode(" " + _toDisplayString(company["ЮрАдрес"]), 1)
                    ]),
                    _createElementVNode("p", null, [
                      _hoisted_8,
                      _createTextVNode(" " + _toDisplayString(company["ИНН"]) + " ", 1),
                      _hoisted_9,
                      _createTextVNode(" " + _toDisplayString(company["ОГРН"]), 1)
                    ])
                  ], 8, _hoisted_4))
                }), 128))
              : _createCommentVNode("", true),
            (
          _ctx.searchResultsIP.length &&
          (_ctx.selectMode === 'ip' || _ctx.selectMode === 'start') &&
          !_ctx.isLoading
        )
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.searchResultsIP, (company) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: company['ИНН'],
                    class: "list-group-item",
                    onClick: ($event: any) => (_ctx.goToCompany(company['ИНН'] || company['ОГРН']))
                  }, [
                    _createElementVNode("h5", null, _toDisplayString(company["НаимСокр"] || company["ФИО"]), 1),
                    (company['Руковод'] && company['Руковод'][0])
                      ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                          _hoisted_12,
                          _createTextVNode(" " + _toDisplayString(company["Руковод"][0]["ФИО"]), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (company['ЮрАдрес'])
                      ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                          _hoisted_14,
                          _createTextVNode(" " + _toDisplayString(company["ЮрАдрес"]["АдресРФ"] || company["ЮрАдрес"]), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", null, [
                      _hoisted_15,
                      _createTextVNode(" " + _toDisplayString(company["ИНН"]) + " ", 1),
                      (company['ОГРН'])
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, "ОГРН:"))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(company["ОГРН"]), 1)
                    ])
                  ], 8, _hoisted_10))
                }), 128))
              : (_openBlock(), _createElementBlock("li", _hoisted_17, _hoisted_19))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_BuyASubscriptionWarningModal, { ref: "subscriptionWarningModal" }, null, 512)
  ], 64))
}